export const SITE_ORIGIN = 'https://www.apdoneright.com';

// Keep the migration canonical even while older deployment settings are replaced.
export const resolveSiteOrigin = (value) => {
  const origin = String(value || '').trim().replace(/\/+$/, '');
  if (!origin || /^https?:\/\/(?:www\.)?(?:apnorthstar|apbiocracked|apdoneright)\.com$/i.test(origin)) {
    return SITE_ORIGIN;
  }
  return origin;
};

// Shared by the live homepage and its build-time HTML so search engines see
// the same brand, description, and answers before and after JavaScript runs.
export const HOME_TITLE = 'APDoneRight | Your Path to a 5';
export const HOME_DESCRIPTION = 'Prepare for 27 AP courses with APDoneRight. Get course-specific AI tutoring, flashcards, study plans and FRQ practice to work toward a 5.';
export const SITE_ALTERNATE_NAMES = ['AP Done Right', 'AP DoneRight', 'APDone Right', 'AP Doneright', 'apdoneright', 'apdoneright.com'];

export const HOME_FAQ_ITEMS = [
  {
    question: 'Is APDoneRight just a general AI chatbot?',
    answer: 'No. It stays inside the AP course you choose, using that course’s language, methods, and scoring expectations.',
  },
  {
    question: 'Will it simply give me the answer?',
    answer: 'No. It helps you unpack the question, choose a method, and work toward an answer you can explain.',
  },
  {
    question: 'Does it work differently for each AP course?',
    answer: 'Yes. Your Tutor context, study plan, flashcards, and course map change with the subject you select.',
  },
  {
    question: 'What is APDoneRight (AP Done Right)?',
    answer: 'APDoneRight, also written AP Done Right, AP DoneRight or APDone Right, is an AP study platform at apdoneright.com. It brings together a course-specific AI tutor, flashcards, and study plans for 27 Advanced Placement courses.',
  },
];
